module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('h1', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Special thanks to:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("My wife, Nancy and daughter, Anna for their support and always accepting me for being me.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("New York Times Best Selling Author, Brad Thor – for complimenting me on my first novel, "), _c('em', [_vm._v("Hell’s Island")]), _vm._v(". A very personable and kind man who not only gave me some of his (valuable, sought after) time to freely offer great advice and share some of his own writing experiences, but encouraged me to write a second novel which he suggested a title: "), _c('em', [_vm._v("Gullah Gravestones")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Shannon Matthews, Rock Hill, SC. Without her support, witty suggestions and especially all the effort she put in the work, this book would not exist.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("I would also like to thank:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Patricia Matthews and her staff at ABS, San Diego, CA, my cousin Dorothy Randall, Atlanta, GA, and E. Gordon Summey, II – The King of the D on P.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0